function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgMoveIcon = function SvgMoveIcon(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20
  }, props), /*#__PURE__*/React.createElement(Path, {
    fill: "none",
    stroke: props.fillLine,
    strokeMiterlimit: 10,
    d: "M9.228 10v1.5c0 .69-.64.95-1.028.95H6.7s-1 0-1 .55.591.898 1 1l4 1m0 0 4 1m-4-1 4-1c.409-.102 1-.5 1-1s-1-.5-1-.5h-1.5c-.389 0-1-.31-1-1V10m-1.5 5-4 1m11-5c-1.995 0-2.952.205-3.5-1-.368-.81-1.17-1.5-2-1.5h-3c-.83 0-1.632.69-2 1.5-.548 1.205-1.505 1-3.5 1m8.5-5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
  }));
};
export default SvgMoveIcon;